document.documentElement.classList.remove('no-js');

document.addEventListener('change', (event) => {
  if (event.target.matches('[data-auto-submit]')) event.target.form?.submit();
});

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (!toggle) return;
  const menu = document.querySelector('[data-mobile-menu]');
  const open = toggle.getAttribute('aria-expanded') === 'true';
  toggle.setAttribute('aria-expanded', String(!open));
  menu.hidden = open;
});

document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
  const track = gallery.querySelector('[data-gallery-track]');
  const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
  const dots = [...gallery.querySelectorAll('[data-gallery-dot]')];
  const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
  const counter = gallery.querySelector('[data-gallery-counter]');
  const previous = gallery.querySelector('[data-gallery-previous]');
  const next = gallery.querySelector('[data-gallery-next]');
  const mobile = window.matchMedia('(max-width: 990px)');
  if (!track || slides.length < 2) return;

  let current = 0;
  const select = (index, move = false) => {
    const active = Math.max(0, Math.min(index, slides.length - 1));
    current = active;
    dots.forEach((dot, item) => {
      if (item === active) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
    thumbs.forEach((thumb, item) => {
      thumb.classList.toggle('is-active', item === active);
      if (item === active) thumb.setAttribute('aria-current', 'true');
      else thumb.removeAttribute('aria-current');
    });
    slides.forEach((slide, item) => {
      slide.classList.toggle('is-active', item === active);
      if (mobile.matches) slide.removeAttribute('aria-hidden');
      else slide.setAttribute('aria-hidden', String(item !== active));
    });
    if (counter) counter.textContent = `${active + 1} / ${slides.length}`;
    if (move) {
      if (mobile.matches) track.scrollTo({ left: slides[active]?.offsetLeft || 0, behavior: 'smooth' });
      thumbs[active]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  };

  let frame = 0;
  track.addEventListener('scroll', () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      const width = track.clientWidth || 1;
      if (mobile.matches) select(Math.round(track.scrollLeft / width));
    });
  }, { passive: true });

  dots.forEach((dot, index) => dot.addEventListener('click', () => select(index, true)));
  thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => select(index, true)));
  previous?.addEventListener('click', () => select((current - 1 + slides.length) % slides.length, true));
  next?.addEventListener('click', () => select((current + 1) % slides.length, true));
  mobile.addEventListener?.('change', () => select(current));
  select(0);
});
